import type { AxiosInstance } from 'axios';
import { AxiosError } from 'axios';
import type { TTokenRes } from 'api/swagger';
import { RefreshTokenUndefinedError, RefreshTokenUnexpectedError } from './auth-custom-error';
import { getRefreshToken, saveTokens } from './auth-tokens-storage';

export const refreshAccessTokenByApi = async (axios: AxiosInstance): Promise<string> => {
  try {
    const refreshToken = getRefreshToken();

    if (!refreshToken) {
      throw new RefreshTokenUndefinedError('Refresh token from cookies is undefined');
    }

    const { data } = await axios.post<TTokenRes>('/v1/auth/refresh', { refreshToken }, { withCredentials: false });
    saveTokens(data);

    return data.accessToken;
  } catch (error) {
    if (error instanceof RefreshTokenUndefinedError) {
      //captureMessage(error.message, { error, level: 'error' });
      throw error;
    }

    if (error instanceof AxiosError) {
      //captureMessage('Refresh is failed with api error', { status: error.status, error, level: 'error' });
      throw error;
    }

    //captureMessage('Refresh is failed with unexpected error', { error, level: 'fatal' });
    throw new RefreshTokenUnexpectedError('Refresh token by api unexpected error');
  }
};
